import React from 'react';
export default function ProgressBar() {
  const questionIndex = Pollfish.helper.getQuestionIndex();
  return (
    <div className="qp-bar clearfix">
      <div id="qp-bar-number" className="qp-bar__number">
        Q{questionIndex}
      </div>
      <div className="qp-bar__line">
        <div id="progressBar"></div>
      </div>
    </div>
  );
}
